import { render } from "./uploadForm.vue?vue&type=template&id=bd341bbc"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"

import "./uploadForm.vue?vue&type=style&index=0&id=bd341bbc&lang=css"
script.render = render

export default script